import { ICommonSettings, ISapServiceBaseUrlSetting } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigSapServiceBaseUrlSettings } from "./app-settings-config-sap-service-base-url-settings";

interface IConfigSapServiceBaseUrlInputState {
  showModal: boolean;
  editingSapServiceBaseUrlId: string;
}

interface IConfigSapServiceBaseUrlInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigSapServiceBaseUrlInput extends PureComponent<
  IConfigSapServiceBaseUrlInputProps,
  IConfigSapServiceBaseUrlInputState
> {
  formInputName = ["apiConfig", "sapServiceBaseUrlSettingsId"];

  constructor(props: IConfigSapServiceBaseUrlInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingSapServiceBaseUrlId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingSapServiceBaseUrlId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingSapServiceBaseUrlId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [
      { id: null, name: "Default" } as unknown as ISapServiceBaseUrlSetting,
      ...(commonSettings.sapServiceBaseUrlSettings?.filter((config) => config.sapServiceBaseUrl) || [])
    ];

    return (
      <>
        <ConfigSapServiceBaseUrlSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingSapServiceBaseUrlId={this.state.editingSapServiceBaseUrlId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <div style={{ marginTop: 16 }}>
          <ConfigSettingSelect
            label="SAP Service Base URL"
            formInputName={this.formInputName}
            options={options}
            tooltipContentKey="appsettings_connectionsettings_sapservicebaseurl"
            onAddNew={this.openModal}
            onEdit={this.setEditingSetting}
            parentConfigValue={this.props.parentConfigValue}
            onRestore={this.handleRestore}
            dropdownTestId="appSettingsSapServiceBaseUrlDropdown"
            addNewTestId="appSettingsSapServiceBaseUrlAddNew"
            editTestId="appSettingsSapServiceBaseUrlEditButton"
          />
        </div>
      </>
    );
  }
}
